export default {
  LIST_FETCHED: 'PLANS_FETCHED',
  LIST_LOAD: 'PLANS_LOAD',
  ITEM_DETAIL: 'PLANS_DETAIL',
  BUTTON_LOAD: 'PLANS_BUTTON_LOAD',
};
